import { useCallback, useEffect, useState } from "react";
import {
  DEFAULT_VALIDATION_POLICY,
  fetchValidationPolicy,
  ValidationPolicy,
} from "../Utils/validationPolicy";

export const useValidationPolicy = () => {
  const [policy, setPolicy] = useState<ValidationPolicy>(DEFAULT_VALIDATION_POLICY);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    const next = await fetchValidationPolicy();
    setPolicy(next);
    setLoaded(true);
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { policy, loaded, refresh };
};
